import React from "react";
import DefaultHeader from "./components/headers/DefaultHeader";

export default function DefaultLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <div className="min-h-screen bg-cbase dark:bg-cbase flex flex-col items-center justify-center px-4">
      <div className="w-full h-16 sm:fixed top-0 left-0">
        <DefaultHeader />
      </div>
      <div className="flex flex-col items-center justify-center w-full h-full">
        {children}
      </div>
    </div>
  );
}
